export default "__VITE_ASSET__DFQwDzno__"